import './QuizStandards.scss';

import * as React from 'react';

import { translate } from '~l10n/client';
import cx from 'classnames';
import { connect } from 'react-redux';

import { SmallButton } from '~shared/components/buttons';

import Standards from '../../../../teacher/edit-quiz/components/Standards';
import { createStandard, updateStandard } from '../../../api/standardApi';
import { handleUnexpectedError } from '../../slices/quiz/quizAppThunks';
import { updateQuizStandard } from '../../slices/quiz/quizSlice';

interface DispatchProps {
  updateQuizStandard?: typeof updateQuizStandard;
  handleUnexpectedError?: typeof handleUnexpectedError;
}
interface ReduxProps {
  standard: {
    dirty: boolean;
    complete: boolean;
    standardsObject?: Record<string, unknown>;
    subject?: any;
    core?: any;
    class?: any;
    standard?: any;
  };
  shouldRender: boolean;
}

interface Props extends ReduxProps, DispatchProps {
  controller: any;
  standardId: number;
  quizId: number;
  onCancelEditStandardClicked: () => void;
  onDeleteStandardClicked: () => void;
}

interface State {
  isEditingStandard: boolean;
}

class QuizStandards extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isEditingStandard: true,
    };
  }

  componentDidMount() {
    if (this.props.standard.complete) {
      this.setState({
        isEditingStandard: false,
      });
    }
  }

  handleOnSave = () => {
    try {
      updateStandard({
        quizId: this.props.quizId,
        standardId: this.props.standardId,
        standard: this.props.standard,
      });
      this.setState({
        isEditingStandard: false,
      });
      this.props.controller.standardChanged('save');
    } catch (e: unknown) {
      handleUnexpectedError(e);
    }
  };

  handleCreateNewStandard = async () => {
    try {
      const response = await createStandard({
        quizId: this.props.quizId,
        standard: this.props.standard,
      });
      const standard = response.data;
      this.props.updateQuizStandard(standard);
      this.setState({
        isEditingStandard: false,
      });
    } catch (e) {
      const { handleUnexpectedError } = this.props;
      handleUnexpectedError(e);
    }
  };

  handleCancel = () => {
    const { onCancelEditStandardClicked } = this.props;
    this.setState({
      isEditingStandard: false,
    });
    onCancelEditStandardClicked();
  };

  handleEditStandard = () => {
    this.props.controller.editStandardClicked();
    this.setState({
      isEditingStandard: true,
    });
  };

  renderStandardFooter() {
    const standard = this.props.standard;
    const saveCallback = this.props.standardId
      ? this.handleOnSave
      : this.handleCreateNewStandard;
    const isDisabled = !(standard.core && standard.class && standard.standard);
    return (
      <div className="flex mt-12 justify-center sm:justify-start">
        <div className="flex min-w-32">
          <SmallButton
            className="flex-1"
            onClick={saveCallback}
            appearance="primary"
            isDisabled={isDisabled}
          >
            {translate('Save')}
          </SmallButton>
        </div>
        <div className="flex min-w-32 ml-4">
          <SmallButton
            className="flex-1"
            onClick={this.handleCancel}
            isOnWhite={false}
          >
            {translate('Cancel')}
          </SmallButton>
        </div>
      </div>
    );
  }

  render() {
    const { isEditingStandard } = { ...this.state };
    const { standard, controller } = this.props;
    const isStandardComplete = standard.complete;
    const quizStandardsStyle = cx(
      'quiz-standards-container shadow-border-t sm:px-8',
      {
        'bg-grey-50 flex-col pt-4 pb-8 px-4':
          !isStandardComplete || this.state.isEditingStandard,
        'flex justify-between pt-5 pb-6': isStandardComplete,
      }
    );

    return (
      <div className={quizStandardsStyle}>
        <Standards
          isNewQuizEditor={true}
          standard={standard}
          controller={controller}
          createNewStandard={this.handleCreateNewStandard}
          hideCompletedStandard={isEditingStandard}
        />
        {isEditingStandard && this.renderStandardFooter()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  updateQuizStandard,
  handleUnexpectedError,
};

const mapStateToProps = (state) => {
  return {
    standard: state.teachers.quizData.standardModel,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuizStandards);
